
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import * as echarts from 'echarts'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    props: ['ringShow'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const options = {
            color:['#b7ac80','#68d4b6'],
            series: [
                {
                    name: 'sale',
                    type: 'pie',
                    radius: ['65%', '100%'],
                    itemStyle: {
                        borderColor: '#f4eaf1',
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    data: [
                        { value: 489, name: '油车' },
                        { value: 511, name: '电车' },
                    ]
                }
            ]
        }

        let myChart: any = null
        const init = () => {
            const dom = document.querySelector('.ring-container') as HTMLDivElement
            myChart = echarts.init(dom)
            myChart.setOption(options)
        }

        watch(() => props.ringShow, (to, from) => {
            if (to) {
                init()
            }
        })
        
        onBeforeUnmount(() => {
            if (myChart != null && myChart.dispose) {
                myChart.dispose()
                myChart = null
            }
        })

        onMounted(() => {
            
        })    

        return {
            
        }
    }
})
